export type LoadedVersionDetails = {
  isBrandMenu: boolean;
  prpMenuVersion: string;
  prpMenuTitle: string;
  brandMenuVersion: string;
  menuVersion: string; // Used for display purpose
};

export const initialItemConversionBusinessRules = {
  comboConversion: [],
  aLaCarteConversion: [],
  defaultSizeSelection: [],
  comboSizeTransformation: [],
};
